import { render, staticRenderFns } from "./ClientContactList.vue?vue&type=template&id=769d2c49"
import script from "./ClientContactList.vue?vue&type=script&lang=js"
export * from "./ClientContactList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports